import { render, staticRenderFns } from "./mo-icon.html?vue&type=template&id=3f85a9a1&scoped=true&external"
import script from "./mo-icon.ts?vue&type=script&lang=ts&external"
export * from "./mo-icon.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-icon.vue?vue&type=style&index=0&id=3f85a9a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f85a9a1",
  null
  
)

export default component.exports